import { render, staticRenderFns } from "./one-click-form.vue?vue&type=template&id=047e2670&scoped=true"
import script from "./one-click-form.vue?vue&type=script&lang=js"
export * from "./one-click-form.vue?vue&type=script&lang=js"
import style0 from "./one-click-form.vue?vue&type=style&index=0&id=047e2670&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047e2670",
  null
  
)

export default component.exports